(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1233],{

/***/ 5191:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(68693);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(87975));
var _jsxRuntime = __webpack_require__(61250);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
}), 'MailOutline');
exports.Z = _default;

/***/ }),

/***/ 27109:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(68693);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(87975));
var _jsxRuntime = __webpack_require__(61250);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
}), 'Phone');
exports.Z = _default;

/***/ }),

/***/ 53888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83027);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99043);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29901);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14517);
/* harmony import */ var _mui_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53664);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2529);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57104);
/* harmony import */ var _Paper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51804);
/* harmony import */ var _cardClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58900);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61250);


const _excluded = ["className", "raised"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,_mui_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _cardClasses__WEBPACK_IMPORTED_MODULE_3__/* .getCardUtilityClass */ .y, classes);
};
const CardRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_Paper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Card(inProps, ref) {
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props, _excluded);
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props, {
    raised
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__["default"])(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Card);

/***/ }),

/***/ 58900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ getCardUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13922);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36163);


function getCardUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiCard', slot);
}
const cardClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiCard', ['root']);
/* harmony default export */ __webpack_exports__["Z"] = (cardClasses);

/***/ }),

/***/ 35192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83027);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99043);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29901);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14517);
/* harmony import */ var _mui_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53664);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2529);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57104);
/* harmony import */ var _cardContentClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61250);


const _excluded = ["className", "component"];








const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,_mui_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _cardContentClasses__WEBPACK_IMPORTED_MODULE_3__/* .getCardContentUtilityClass */ .N, classes);
};
const CardContentRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CardContent(inProps, ref) {
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiCardContent'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, _excluded);
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props, {
    component
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardContentRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    as: component,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__["default"])(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (CardContent);

/***/ }),

/***/ 8092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ getCardContentUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13922);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36163);


function getCardContentUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiCardContent', slot);
}
const cardContentClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiCardContent', ['root']);
/* harmony default export */ __webpack_exports__["Z"] = (cardContentClasses);

/***/ }),

/***/ 67972:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help",
      function () {
        return __webpack_require__(1216);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ help; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(13459);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(26806);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@BlackbirdHQ+ui-base@0.1.0_@emotion+react@11.11.1_@emotion+styled@11.11.0_@mui+icons-material_kyohckkzppuivf3qidsibfbiei/node_modules/@BlackbirdHQ/ui-base/dist/es/index.js + 8 modules
var es = __webpack_require__(330);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/MailOutline.js
var MailOutline = __webpack_require__(5191);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Phone.js
var Phone = __webpack_require__(27109);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(53888);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(35192);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(27908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(1827);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(21586);
;// CONCATENATED MODULE: ./views/help-page.tsx















var styles = function(theme) {
    return {};
};
var HelpPage = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(HelpPage, _Component);
    var _super = (0,_create_super/* default */.Z)(HelpPage);
    function HelpPage() {
        (0,_class_call_check/* default */.Z)(this, HelpPage);
        return _super.apply(this, arguments);
    }
    var _proto = HelpPage.prototype;
    _proto.render = function render() {
        var _props = this.props, t = _props.t, theme = _props.theme;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            direction: "column",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 12,
                md: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    elevation: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h3",
                                    children: t([
                                        "shared:help"
                                    ], {
                                        defaultValue: "Help"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "h5",
                                    style: {
                                        marginTop: theme.spacing(3)
                                    },
                                    children: [
                                        "1. ",
                                        t([
                                            "shared:helpToSelfHelp"
                                        ], {
                                            defaultValue: "Help to self-help"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            children: t([
                                                "shared:helpCenterExplanation1"
                                            ], {
                                                defaultValue: "Check out our"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            color: "secondary",
                                            style: {
                                                marginLeft: theme.spacing(0.5),
                                                marginRight: theme.spacing(0.5)
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Link */.rU, {
                                                href: "https://www.notion.so/factbird/Help-Center-bcefd44b60cf42ec88e87b8296c824ff",
                                                target: "_blank",
                                                children: t([
                                                    "shared:helpCenter"
                                                ], {
                                                    defaultValue: "Help Center"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            children: [
                                                t([
                                                    "shared:helpCenterExplanation2"
                                                ], {
                                                    defaultValue: "with documentation of features and tips for using the Factbird system"
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "h5",
                                    style: {
                                        marginTop: theme.spacing(3)
                                    },
                                    children: [
                                        "2. ",
                                        t([
                                            "shared:stillHaveMoreQuestions"
                                        ], {
                                            defaultValue: "Still have more questions?"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    children: [
                                        t([
                                            "shared:contactOurSupport"
                                        ], {
                                            defaultValue: "Contact our Factbird support where we are happy to answer any questions"
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    style: {
                                        margin: 1 / 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MailOutline/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            style: {
                                                marginLeft: theme.spacing()
                                            },
                                            children: "support@factbird.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    style: {
                                        margin: 1 / 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            style: {
                                                marginLeft: theme.spacing()
                                            },
                                            children: "+45 21 39 59 66"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "h5",
                                    style: {
                                        marginTop: theme.spacing(3)
                                    },
                                    children: [
                                        "3. ",
                                        t([
                                            "shared:systemStatus"
                                        ], {
                                            defaultValue: "System status"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            children: t([
                                                "shared:systemStatusExplanation1"
                                            ], {
                                                defaultValue: "Keep track of the"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            color: "secondary",
                                            style: {
                                                marginLeft: theme.spacing(0.5),
                                                marginRight: theme.spacing(0.5)
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Link */.rU, {
                                                href: "https://status.blackbird.online/",
                                                target: "_blank",
                                                children: t([
                                                    "shared:systemStatus"
                                                ], {
                                                    defaultValue: "System status"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            children: t([
                                                "shared:systemStatusExplanation2"
                                            ], {
                                                defaultValue: "at all times at the bottom right corner of the page. Click on the link to see the full status and optionally subscribe to updates."
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    style: {
                                        width: "300px"
                                    },
                                    src: "/images/system-status.png"
                                })
                            ]
                        })
                    })
                })
            })
        });
    };
    return HelpPage;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared"
]), (0,with_styles/* withStyles */.D)(styles, {
    withTheme: true
}));
/* harmony default export */ var help_page = (enhance(HelpPage));

;// CONCATENATED MODULE: ./pages/help/index.tsx


var Help = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(help_page, {});
};
var __N_SSG = true;
/* harmony default export */ var help = (Help);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(67972); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);